import { useMemo, useCallback } from "react";
import { calculateGrandTotal, createCustomerCardData } from "./customerProductDetail";
// import { createCustomerCardData, calculateGrandTotal } from "../utils/orderCalculations";

export const useOrderCalculations = (data, type) => {
  // Memoize grand total
  const grandTotal = useMemo(() => {
    return calculateGrandTotal(data?.details, type, data?.paymentmode);
  }, [data?.details, type, data?.paymentmode]);

  // Memoize unassigned products
  const unassignedProducts = useMemo(() => {
    if (type === "6") {
      return data?.details || [];
    }
    return data?.details?.filter((product) => product.orderstatus == 1) || [];
  }, [data?.details, type]);

  // Memoize payment slips
  const paymentSlips = useMemo(
    () =>
      (data?.details || []).filter((d) => d?.payment_slip && d.payment_slip !== "null"),
    [data?.details]
  );

  // Memoized card data creator
  const getCustomerCardData = useCallback(
    (customer) => {
      return createCustomerCardData(customer, type, data?.paymentmode);
    },
    [type, data?.paymentmode]
  );

  return {
    grandTotal,
    unassignedProducts,
    paymentSlips,
    getCustomerCardData,
  };
};